import ajax from '@/utils/request'

// 设备列表
export const deviceList = data => ajax('/api/device/get/list/', data, 'POST')
export const deviceCodeList = data => ajax('/api/device/get/code/list/', data, 'POST')
// 详情
export const deviceDetail = data => ajax('/api/device/get/', data, 'GET')
// 添加
export const deviceAdd = data => ajax('/api/device/addDevice/', data, 'POST')
// 为设备绑定码牌
export const bindMerchant = data => ajax('/api/merchant/bind/', data, 'POST')
// 解绑设备绑定的码牌
export const unbindMerchant = data => ajax('/api/merchant/unbind/', data, 'GET')
// 设备汇总
export const deviceNum = data => ajax('/api/device/statistics/', data, 'GET')
// 产品标识
export const deviceSpec = data => ajax('/api/device/findDeviceSpec/', data, 'GET')
// 推送播报测试
export const pushMessage = data => ajax('/api/device/push/message/', data, 'POST')
// 推送音频流测试
export const pushAudio = (deviceCode, data) => ajax(`/api/device/push/audio/${deviceCode}`, data, 'POST')
// 推送AT指令
export const pushAT = (deviceCode, data) => ajax(`/api/device/push/at/${deviceCode}`, data, 'POST')
// 获取设备规格
export const getDeviceSpec = data => ajax('/api/devicespec/getDeviceSpec/', data, 'GET')
// 开关机模板、生成文件
export const audioMake = data => ajax('/api/audio/make/', data, 'POST')
// 轮询AT响应
export const queryATReply = deviceCode => ajax(`/api/device/at/reply/${deviceCode}`, '', 'GET')
// 导入设备
export const deviceImportFile = data => ajax('/api/deviceImport/file/', data, 'POST')
// 批量绑定商户
export const batchBind = data => ajax('/api/merchant/batchBind/', data, 'POST')
// 批量删除设备
export const batchDelete = data => ajax('/api/device/delete/batch', data, 'POST')
// 根据查询条件删除设备
export const queryDelete = data => ajax('/api/device/delete/query', data, 'POST')
// 批量迁移设备
export const batchMigrate = data => ajax('/api/device/migrate/batch', data, 'POST')
// 根据查询条件批量迁移
export const queryMigrate = data => ajax('/api/device/migrate/query', data, 'POST')
// 下载设备导入模版
export const downloadTemplate = data => ajax('/api/deviceImport/downloadTemplate/', data, 'DOWNLOAD')
// 下载设备导入失败详情文件
export const downloadFailDetail = data => ajax('/api/deviceImport/downloadDetail/', data, 'download')
// 下载商户导入模版
export const downloadBindTemplate = data => ajax('/api/merchant/download/bindTemplate/', data, 'DOWNLOAD')
// 下载绑定导入失败详情文件
export const downloadBindErrorDetail = data => ajax('/api/merchant/downloadErrorDetail/', data, 'download')
